import { $post, $get } from "@/utils/request";
import { message } from "ant-design-vue";

export const login = function (form, callback) {
  $post({
    url: "auth/login",
    params: form,
  })
    .then((res) => {
      message.success("登录成功", 4);
      callback(`Bearer ${res.token}`);
    })
    .catch((err) => {
      form.password = "";
      console.log(err);
      message.error(err, 4);
    });
};
export const getLic = function () {
  return new Promise((resolve, reject) => {
    $get({
      url: 'auth/lic',
    }).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err)
    })
  })
};